import { nriGuaranteeData, nriWhatsappUrl } from "../../data/nriTaxData";
import { Shield, ArrowRight } from "lucide-react";

const guaranteePoints = [
  { label: "Prior-year audit included", detail: "I check your last 2 ITRs before you commit to anything." },
  { label: "Zero charge if no issues found", detail: "Clean filing = you pay only for this year's ITR. No audit fee." },
  { label: "IT notice response included", detail: "If your ITR is queried on anything in my scope — I handle it. No hourly fees. No revision charges." },
];

export const NriGuaranteeSection = () => (
  <section id="nri-guarantee" className="relative py-28" style={{ background: "#252422" }}>
    <div className="absolute top-0 left-0 right-0 h-px bg-[#3f4816]/30" />
    <div className="max-w-[87.5rem] mx-auto px-10">

      {/* Heading */}
      <div className="mb-14 text-center">
        <span className="inline-block text-[#888680] text-xs font-medium uppercase tracking-[0.2em] mb-5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {nriGuaranteeData.sectionLabel}
        </span>
        <p className="text-[#888680]/60 font-semibold uppercase mb-1" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(0.85rem, 0.7rem + 0.6vw, 1rem)", letterSpacing: "-0.01em" }}>
          The zero discovery
        </p>
        <h2 className="font-black uppercase leading-tight" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.8rem, 1.4rem + 2.5vw, 3.5rem)", letterSpacing: "-0.03em" }}>
          <span className="text-[#d9fb06]">Guarantee</span>
        </h2>
      </div>

      <div className="max-w-3xl mx-auto">
        {/* 3 guarantee points */}
        <div className="bg-[#1a1c1b] border border-[#d9fb06]/20 rounded-sm p-8 mb-5">
          <div className="flex flex-col items-center mb-8">
            <div className="w-14 h-14 rounded-full bg-[#d9fb06]/10 border border-[#d9fb06]/20 flex items-center justify-center mb-3">
              <Shield size={26} className="text-[#d9fb06]" />
            </div>
            <p className="text-[#888680] text-xs uppercase tracking-widest" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>My Promise</p>
          </div>

          <div className="flex flex-col gap-4">
            {guaranteePoints.map((p, i) => (
              <div key={i} className="flex items-start gap-4 py-4 border-b border-[#3f4816]/15 last:border-b-0">
                <div className="w-7 h-7 rounded-full bg-[#d9fb06]/10 border border-[#d9fb06]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-[#d9fb06] text-xs font-black" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{i + 1}</span>
                </div>
                <div>
                  <p className="text-[#dfddd6] font-bold text-sm mb-1" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{p.label}</p>
                  <p className="text-[#888680] text-xs leading-relaxed" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{p.detail}</p>
                </div>
              </div>
            ))}
          </div>

          <p className="text-[#d9fb06] font-black text-base mt-6 text-center" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            You are not risking your money.
          </p>
        </div>

        {/* Risk framing */}
        <div className="bg-[#302f2c]/40 border border-[#3f4816]/20 rounded-sm p-5 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-start gap-3">
              <span className="text-[#d9fb06] font-black text-lg flex-shrink-0 leading-none" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>→</span>
              <div>
                <p className="text-[#dfddd6] text-xs font-bold mb-0.5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>Risk of acting</p>
                <p className="text-[#888680] text-xs" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>30 minutes on a call.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-red-400 font-black text-lg flex-shrink-0 leading-none" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>→</span>
              <div>
                <p className="text-[#dfddd6] text-xs font-bold mb-0.5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>Risk of NOT acting</p>
                <p className="text-[#d9fb06] text-xs font-bold" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>₹15–50 lakh over 3–5 years.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <a href={nriWhatsappUrl} target="_blank" rel="noopener noreferrer" data-testid="nri-guarantee-cta"
            className="group inline-flex items-center gap-2 bg-[#d9fb06] text-[#1a1c1b] font-bold text-sm px-8 py-4 rounded-full transition-all duration-300 hover:scale-[1.02] hover:opacity-90 uppercase tracking-tight"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            Start My NRI Tax Report + Filing
            <ArrowRight size={15} className="transition-transform group-hover:translate-x-0.5 duration-300" />
          </a>
        </div>
      </div>
    </div>
  </section>
);
